<template>
  <div class="charts">
    <div v-if="loader">
      <i class="el-icon-loading"></i>
    </div>
    <Chart
      v-else-if="datacollection.labels.length > 0"
      :style="myStyles"
      :chart-data="datacollection">
    </Chart>
  </div>
</template>

<script>
  import Chart from './Chart';
  import TxProxy from '../../../proxies/TxProxy';
  import moment from 'moment';

  export default {
    name: 'MinChartContainer',
    components: { Chart },
    props: ['name', 'totalSupply'],
    computed: {
      myStyles() {
        return {
          height: '86px',
          width: '210px',
          position: 'relative',
        };
      }
    },
    async mounted() {
      const tx_proxy = new TxProxy();

      const charts = await tx_proxy.charts(this.name);
      const init_supply = this.totalSupply - charts.total

      charts.charts.data.unshift(init_supply);
      charts.charts.labels.unshift('');
      let total = 0;
      this.datacollection.datasets[0].data = charts.charts.data.map((d) => {
        total = d + total;
        return total;
      });
      this.datacollection.labels = charts.charts.labels;
      if( this.datacollection.datasets[0].data.length < 2) {
        this.datacollection.labels.push('');
        this.datacollection.datasets[0].data.push(init_supply)
      }
      this.loader = false;
    },
    data: function () {
      return {
        time: '1d',
        loader: true,
        datacollection: {
          labels: [],
          datasets: [
            {
              label: 'Supply',
              backgroundColor: 'rgba(64,158,255, 0)',
              data: [],
              borderColor: [
                '#d2f400',
              ],
              borderWidth: 2.4
            }
          ]
        }
      };
    }
  };
</script>

<style scoped lang="scss">
  .charts {
    i{
      font-size: 16px;
      margin-left: 20px;
      display: block;
    }
    text-align: center;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    min-width: 72px;
    max-height: 58px;
  }

  .text-grey {
    margin-bottom: 20px;
  }
</style>
